<template src="./index.html">
</template>
<script>
	export default {
		name: '',
		components: {},
		props: {
			showdownload: {
				type: Boolean,
				default: false
			},
			filets: {
				type: String,
				default: '通过一个.xls、.xlsx文件你最多可以导入5000条记录'
			},
			filets2: {
				type: String,
				default: ''
			},
			alowfiletype:{
				type:String,
				default:''
			},
			fileParams:{
				type:Object,
				default: function() {
					return {
						upfilename:"",
						upfile:"",
						filestate:"",
						filetype:"",
						filesize:""
					} 
				}
			}
		},
		data: function() {
			return {
			};
		},
		mounted() {
			let dropArea = document.getElementById('drop-area')
			dropArea.addEventListener('drop', this.dropEvent, false)
			dropArea.addEventListener('dragleave', (e) => {
				e.stopPropagation()
				e.preventDefault()
				this.dropActive = false
			})
			dropArea.addEventListener('dragenter', (e) => {
				e.stopPropagation()
				e.preventDefault()
				this.dropActive = true
			})
			dropArea.addEventListener('dragover', (e) => {
				e.stopPropagation()
				e.preventDefault()
				this.dropActive = true
			})
		},
		methods: {
			fordownloadmb(){
				this.$emit("fordownloadmb",true)
			},
			forrefresh(){
				this.fileParams.upfilename = ""
				this.fileParams.upfile = ""
				this.fileParams.filestate = null
			},
			dropEvent(e) {
				this.dropActive = false
				e.stopPropagation()
				e.preventDefault()
				this.uploadFile(e.dataTransfer.files)
			},
			uploadFile(files) { // 渲染上传文件
				 let file=files[0]
				 if((file.size/1024/1024)>100){
				 	this.$message.error('文件不能超过100M')
				 	return false
				 }
				 this.fileParams.upfilename = file.name
				 this.fileParams.filetype=file.name.split(".")[1]
				 if(this.$notemptyandnull(this.alowfiletype)&&(!this.alowfiletype.split(",").includes(this.fileParams.filetype))){
				 		this.$message.error('当前文件类型不支持上传')
						return false
				 }
				 this.fileParams.filesize=(file.size/1024).toFixed(2)
				 this.fileParams.upfile = file
				 this.$emit("getuploadparams", this.fileParams)
			},
			uploadFileclick($event) {
				let file=$event.target.files[0]
				if((file.size/1024/1024)>100){
					this.$message.error('文件不能超过100M')
					return false
				}
				this.fileParams.upfilename = file.name
				this.fileParams.filetype=file.name.split(".")[1]
				if(this.$notemptyandnull(this.alowfiletype)&&(!this.alowfiletype.split(",").includes(this.fileParams.filetype))){
						this.$message.error('当前文件类型不支持上传')
						return false
				}
				this.fileParams.filesize=(file.size/1024).toFixed(2)
				this.fileParams.upfile = file
				 this.$emit("getuploadparams",this.fileParams)
			},
		}
	};
</script>


<style scoped lang="less">
	@import url("./index.less");
</style>
